<template>
  <GroupCategories viewName="search"></GroupCategories>
</template>

<script>
import GroupCategories from "@/components/order/GroupCategories.vue";

export default {
  components: {
    GroupCategories,
  },
};
</script>
